export type NoteBodySegment = { type: 'text'; value: string } | { type: 'url'; href: string }

const HTTPS_URL_RE = /(https:\/\/[^\s<>()[\]"]+)/g

function stripTrailingPunctuation(url: string): { href: string; trailing: string } {
  const href = url.replace(/[),.;:!?'"]+$/u, '')
  return { href, trailing: url.slice(href.length) }
}

export function splitNoteBody(body: string): NoteBodySegment[] {
  const segments: NoteBodySegment[] = []
  let lastIndex = 0
  HTTPS_URL_RE.lastIndex = 0

  for (const match of body.matchAll(HTTPS_URL_RE)) {
    const raw = match[1]
    const index = match.index ?? 0
    if (index > lastIndex) {
      segments.push({ type: 'text', value: body.slice(lastIndex, index) })
    }
    const { href, trailing } = stripTrailingPunctuation(raw)
    if (href.length > 0) {
      segments.push({ type: 'url', href })
    }
    if (trailing.length > 0) {
      segments.push({ type: 'text', value: trailing })
    }
    lastIndex = index + raw.length
  }

  if (lastIndex < body.length) {
    segments.push({ type: 'text', value: body.slice(lastIndex) })
  }

  return segments.length > 0 ? segments : [{ type: 'text', value: body }]
}
